<template>
  <div class="d-flex webhook-integration-row webhook-integration-item align-center">
    <div>
      <div class="pl-4">
        <span class="font-weight-medium">{{ integration.name }}</span>
        <span v-if="integration.description" class="text-caption d-block text-grey text-truncate">
          {{ integration.description }}
        </span>
      </div>
    </div>
    <div>{{ typeLabel }}</div>
    <div>
      <v-chip :color="stateColor" size="small" variant="tonal">
        {{ $t(`routes.webhookIntegrations.states.${integration.state}`) }}
      </v-chip>
    </div>
    <div><span class="text-caption">{{ createdAt }}</span></div>
    <div>
      <v-btn icon variant="text" width="32" height="32" rounded="circle" @click="$emit('view', integration)">
        <v-icon>mdi-eye-outline</v-icon>
      </v-btn>
      <v-menu v-if="$canControlTenantConfig()" v-model="showingMenu">
        <template v-slot:activator="{ props }">
          <v-btn icon variant="text" width="32" height="32" rounded="circle" v-bind="props">
            <v-icon>mdi-dots-vertical</v-icon>
          </v-btn>
        </template>
        <v-list>
          <v-list-item @click="emitAction('edit')">
            <template v-slot:prepend><v-icon size="small">mdi-pencil-outline</v-icon></template>
            <v-list-item-title>{{ $t('routes.webhookIntegrations.edit') }}</v-list-item-title>
          </v-list-item>
          <v-list-item v-if="integration.state !== 'active'" @click="emitState('active')">
            <template v-slot:prepend><v-icon size="small">mdi-play-circle-outline</v-icon></template>
            <v-list-item-title>{{ $t('routes.webhookIntegrations.resume') }}</v-list-item-title>
          </v-list-item>
          <v-list-item v-if="integration.state === 'active'" @click="emitState('paused')">
            <template v-slot:prepend><v-icon size="small">mdi-pause-circle-outline</v-icon></template>
            <v-list-item-title>{{ $t('routes.webhookIntegrations.pause') }}</v-list-item-title>
          </v-list-item>
          <v-list-item v-if="integration.state !== 'disabled'" @click="emitState('disabled')">
            <template v-slot:prepend><v-icon size="small">mdi-cancel</v-icon></template>
            <v-list-item-title>{{ $t('routes.webhookIntegrations.disable') }}</v-list-item-title>
          </v-list-item>
          <v-divider />
          <v-list-item style="cursor: pointer;" @click="openDeleteDialog">
            <template v-slot:prepend><v-icon size="small" color="error">mdi-delete-outline</v-icon></template>
            <v-list-item-title class="text-error">{{ $t('routes.webhookIntegrations.delete') }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </div>

    <DeleteWebhookIntegrationDialog
      v-model="showDeleteDialog"
      :title="$t('routes.webhookIntegrations.deleteIntegration')"
      :message="$t('routes.webhookIntegrations.confirmDeleteIntegration')"
      @confirm="emitAction('delete')"
    />
  </div>
</template>

<script>
import DeleteWebhookIntegrationDialog from './dialogs/DeleteWebhookIntegrationDialog.vue';
import { formatDate, formatWebhookType, getStateColor } from '../WebhookConstants.js';

export default {
  name: 'WebhookIntegrationItem',
  components: { DeleteWebhookIntegrationDialog },
  props: {
    integration: {
      type: Object,
      required: true,
    },
    integrationTypes: {
      type: Array,
      required: true,
    },
  },
  emits: ['edit', 'delete', 'state', 'view'],
  data() {
    return { showingMenu: false, showDeleteDialog: false };
  },
  computed: {
    typeLabel() {
      const type = this.integrationTypes.find((item) => item.id === this.integration.type);
      return type?.label || formatWebhookType(this.integration.type);
    },
    stateColor() {
      return getStateColor(this.integration.state);
    },
    createdAt() {
      return formatDate(this.integration.created_at);
    },
  },
  methods: {
    emitAction(action) {
      this.showingMenu = false;
      this.$emit(action, this.integration);
    },
    emitState(state) {
      this.showingMenu = false;
      this.$emit('state', { integration: this.integration, state });
    },
    openDeleteDialog() {
      this.showingMenu = false;
      this.showDeleteDialog = true;
    },
  },
}
</script>

<style scoped lang="scss">
.webhook-integration-item {
  min-height: 64px;
  border-radius: 8px;
  margin-bottom: 4px;
}

.v-theme--dark .webhook-integration-item {
  background-color: #1e1e1e;
}

.v-theme--light .webhook-integration-item {
  background-color: #fafafa;
}
</style>
